// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2ISHZ","inner":"Footer_inner__33WmZ"};